import { decode } from "blurhash";

export const DEFAULT_BLURHASH = "LfLXGOtQj=xZ~ptQWARjocoLada}";

export interface RGBColor {
  r: number;
  g: number;
  b: number;
}

export const updateBlur = (
  hash: string | undefined,
  data: { width: number; height: number },
): string | undefined => {
  if (!hash) return undefined;
  // Get the dimensions of the container div

  // Create a canvas element with the same dimensions
  const canvas = document.createElement("canvas");

  canvas.width = data.width;
  canvas.height = data.height;

  const ctx = canvas.getContext("2d");

  if (!ctx) return undefined;

  const imageData = ctx.createImageData(data.width, data.height);
  const pixels = decode(hash, data.width, data.height);

  // Assume pixels is a Uint8ClampedArray with width*height*4 elements
  imageData.data.set(pixels);
  ctx.putImageData(imageData, 0, 0);

  return canvas.toDataURL();
};

const extractRGBValues = (
  pixels: any[] | Uint8ClampedArray,
  x: number,
  y: number,
  width: number
) => {
  const index = 4 * x + y * width * 4;
  const red = pixels[index];
  const green = pixels[index + 1];
  const blue = pixels[index + 2];
  return [red, green, blue];
};

export const decodeAverageColor = (blurHash: string): RGBColor | null => {
  let pixels = decode(blurHash, 200, 200);
  const rgbValues = extractRGBValues(pixels, 0, 0, 200);
  return { r: rgbValues[0], g: rgbValues[1], b: rgbValues[2] };
};
